import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    ProductCardContainer as SourceProductCardContainer
} from 'SourceComponent/ProductCard/ProductCard.container';
import componentLoader from 'Util/componentLoader';
import history from 'Util/History';
import { appendWithStoreCode } from 'Util/Url';

export const CartDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Cart/Cart.dispatcher'
), 2);

export const ProductsVariantsDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/ProductsVariants/ProductsVariants.dispatcher'
), 2);
/** @namespace Bodypwa/Component/ProductCard/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    requestProductListVariants: (options) => ProductsVariantsDispatcher.then(
        ({ default: dispatcher }) => dispatcher.handleData(dispatch, options)
    )
});

/** @namespace Bodypwa/Component/ProductCard/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    categoryId: state.ProductListReducer.id,
    pages: state.ProductListReducer.pages,
    categoryPage: state.ProductListReducer.categoryPage
});
/** @namespace Bodypwa/Component/ProductCard/Container */
export class ProductCardContainer extends SourceProductCardContainer {
    containerProps() {
        const {
            isSwiper,
            variantsPage,
            pages,
            categoryPage,
            categoryId,
            requestProductListVariants
        } = this.props;

        return {
            ...super.containerProps(),
            isSwiper,
            variantsPage,
            pages,
            categoryPage,
            categoryId,
            requestProductListVariants
        };
    }

    getLinkTo() {
        const {
            baseLinkUrl,
            productUsesCategories,
            categoryUrlSuffix,
            product: { url, url_rewrites = [] },
            product
        } = this.props;
        const { pathname: storePrefix } = new URL(baseLinkUrl || window.location.origin);
        const { location: { pathname } } = history;

        if (!url) {
            return undefined;
        }

        const { state: { category = null } = {} } = history.location;
        const categoryUrlPart = pathname.replace(storePrefix, '').replace(categoryUrlSuffix, '');
        const productUrl = `${categoryUrlPart}/${url.replace(storePrefix, '')}`;

        // if 'Product Use Categories' is enabled then use the current window location to see if the product
        // has any url_rewrite for that path. (if not then just use the default url)
        const rewriteUrl = url_rewrites.find(({ url }) => url.includes(productUrl)) || {};
        const rewriteUrlPath = productUsesCategories
            ? (rewriteUrl.url && appendWithStoreCode(rewriteUrl.url)) || url
            : url;

        return {
            pathname: rewriteUrlPath,
            state: { product, prevCategoryId: category },
            search: ''
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductCardContainer);
